import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { CartBrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { updateLastBC } from 'api/operations/cartServiceV2';
import { action, makeObservable, observable, runInAction, toJS } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

export interface ExpectedGroupSizeModalContext {
  getCartId: () => string;
  getBrowsingCriteria: () => CartBrowsingCriteria;
  onBackRedirect: () => void;
  refreshCart: (cartId: string) => Promise<void>;
}

interface Fields extends DefaultFormFields {
  groupSize: FormControl<string>;
}

export class ExpectedGroupSizeModalStore extends ModalDelegate {
  private readonly _contextualData: ExpectedGroupSizeModalContext;

  public readonly form = new FormController<Fields>(
    {
      groupSize: new FormControl('', {
        optional: false,
        trim: true,
        validations: ['containsOnlyNumbers'],
        customValidations: [{ check: (value: string): boolean => Number(value) > 0, msg: 'Cannot be less than 1' }],
      }),
    },
    {
      onSubmit: this._saveGroupSize.bind(this),
    },
  );

  private async _saveGroupSize(): Promise<void> {
    const { cartId, browsingCriteria } = runInAction(() => ({
      cartId: this._contextualData.getCartId(),
      browsingCriteria: {
        ...toJS(this._contextualData.getBrowsingCriteria()),
        groupSize: this.form.fields.groupSize.value,
      },
    }));

    await updateLastBC(cartId, browsingCriteria);
    runInAction(() => {
      this.close();
    });
    await this._contextualData.refreshCart(cartId);
  }

  public onClose(): void {
    this.close();
    this._contextualData.onBackRedirect();
  }

  constructor(props: ExpectedGroupSizeModalContext) {
    super();
    this._contextualData = props;

    makeObservable<ExpectedGroupSizeModalStore, '_saveGroupSize'>(this, {
      _saveGroupSize: action.bound,
      form: observable,
      onClose: action.bound,
    });
  }
}
